import useOnMount from 'hooks/useOnMount'
import useUsercentrics from 'hooks/useUsercentrics'
import { analytics } from 'services/Analytics/Analytics'
import { useNoSSR } from 'utils/NoSSR'
import { useSetInitialCoupon } from '../../hooks/useSetInitialCoupon'
import { useExperimentManager } from 'services/ExperimentManager/ExperimentManager'
import { SERVER_EVALUATED_FEATURES } from 'services/ExperimentManager/Experiments.consts'
import { useInitClientServices } from './rootUtils.client'

export default function RootClientInit() {
  const isClient = useNoSSR()

  useOnMount(() => {
    analytics.trackFirstOpen()
  })

  return (
    <>
      {!!useInitClientServices && <ClientServicesInit />}
      {isClient && <ClientInit />}
    </>
  )
}

function ClientServicesInit() {
  useInitClientServices()
  return null
}

function ClientInit() {
  const experimentManager = useExperimentManager()

  useUsercentrics()
  useSetInitialCoupon()

  useOnMount(() => {
    // Some feature flags are only evaluated on the server side (e.g. to decide
    // whether the quiz-first navigation should happen). Since they're never read on the
    // client, reading them here on the analytics-wired client records their Amplitude exposure.
    SERVER_EVALUATED_FEATURES.forEach((feature) =>
      experimentManager.isEnabled(feature)
    )
  })

  return null
}
